import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const Container = styled.div(() =>
  mq({
    padding: [0, 0, defaultTheme.spacing.l, defaultTheme.spacing.l],
  }),
);

export const Title = styled.h2(() =>
  mq({
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: [
      defaultTheme.font.size.m,
      defaultTheme.font.size.m,
      defaultTheme.font.size.l,
      defaultTheme.font.size.l,
    ],
  }),
);

export const Text = styled.p(() =>
  mq({
    textAlign: 'center',
    color: defaultTheme.color.secondary,
    fontSize: [
      defaultTheme.font.size.s,
      defaultTheme.font.size.s,
      defaultTheme.font.size.m,
      defaultTheme.font.size.m,
    ],
    marginTop: defaultTheme.spacing.l,
  }),
);

export const TextNote = styled.span(() =>
  mq({
    display: 'block',
    fontSize: defaultTheme.font.size.s,
    marginTop: defaultTheme.spacing.l,
  }),
);

export const ButtonWrapper = styled.div(() =>
  mq({
    textAlign: 'center',
    marginTop: defaultTheme.spacing.xxl,
  }),
);

export const Notice = styled.p(() =>
  mq({
    color: defaultTheme.color.grayScale.dark,
    textAlign: 'center',
    fontSize: [
      defaultTheme.font.size.s,
      defaultTheme.font.size.s,
      defaultTheme.font.size.m,
      defaultTheme.font.size.m,
    ],
    marginTop: defaultTheme.spacing.xxl,
    a: {
      textDecoration: 'underline',
    },
  }),
);
